<template>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template #activator="{ props, on }">
      <v-chip small v-bind="props" v-on="on" color="primary">{{
        label
      }}</v-chip>
    </template>
    <v-card
      class="pa-3 d-flex flex-column gap-2 rounded-lg"
      style="width: 290px"
    >
      <b>Canal</b>

      <div class="d-flex gap-2 justify-space-between">
        <v-chip
          v-for="channel in channels"
          :key="channel.id"
          small
          @click="toggleChannel(channel)"
          class="flex-grow-1"
          :input-value="
            localFilters?.channel?.length === 0 ||
            localFilters?.channel?.includes(channel.id)
          "
          filter
          :color="
            localFilters?.channel?.includes(channel.id)
              ? 'primary'
              : 'secondary'
          "
        >
          {{ channel.name }}
        </v-chip>
      </div>
      <div class="d-flex justify-space-between mt-2">
        <v-btn text color="primary" @click="cancel" small> Cancelar </v-btn>
        <v-btn color="primary" @click="save" depressed small> Aplicar </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    channels: [
      { id: "site", name: "Site" },
      { id: "promoter", name: "Promoter" },
      { id: "pos", name: "POS" },
    ],
    localFilters: null,
    menu: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.load(newValue);
      },
    },
    menu: {
      immediate: true,
      handler(newValue) {
        if (!newValue) this.save();
        else this.load();
      },
    },
  },
  methods: {
    save() {
      this.menu = false;
      this.filters = Object.assign(this.filters, {
        channel: this.localFilters.channel,
      });
    },
    load(value) {
      this.localFilters = structuredClone(value || this.value);
    },
    cancel() {
      this.load();
      this.menu = false;
    },
    toggleChannel(channel) {
      if (this.localFilters.channel.includes(channel.id)) {
        if (this.localFilters.channel.length === 1) return;
        this.localFilters.channel = this.localFilters.channel.filter(
          (c) => c !== channel.id
        );
      } else {
        this.localFilters.channel.push(channel.id);
      }
    },
  },
  computed: {
    label() {
      if (this.filters?.channel?.length === 0) return "Todos os canais";
      if (this.filters?.channel?.length === this.channels.length)
        return "Todos os canais";

      if (this.filters?.channel?.length === 1) {
        const channel = this.channels.find(
          (ch) => ch.id === this.filters?.channel[0]
        );
        return `Apenas ${channel.name}`;
      }

      return this.filters?.channel
        ?.map((c) => this.channels.find((ch) => ch.id === c).name)
        .join(", ");
    },
    filters: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
